import ServicePageTemplate from "../../components/ServicePageTemplate";
import { IMAGES } from "../../lib/assets";

// NOTE TO MIGUEL / CONTENT EDITOR:
// Replace everything wrapped in [SQUARE BRACKETS] with final copy.

export default function TilingPage() {
  return (
    <ServicePageTemplate
      seo={{
        slug: "tiling",
        // SEO TITLE — primary keywords: tiling Auckland, bathroom tiling,
        // commercial tiling
        title:
          "Bathroom & Commercial Tiling Auckland & Christchurch | Trust Flooring & Interiors",
        // META DESCRIPTION — 150–160 characters
        description:
          "Bathroom, kitchen and commercial tiling across Auckland, Christchurch and New Zealand — wall tiling, floor tiling, tiles on pedestals and interior waterproofing by Trust Flooring & Interiors.",
        canonical: "https://trustflooring.co.nz/services/tiling",
      }}
      eyebrow="Services — Tiling"
      h1="Tiling for wet areas, feature walls and commercial floors."
      // [INSERT HERO IMAGE — tiled bathroom, commercial tiled floor or
      // waterproofed wet area]
      heroImage={IMAGES.tiling}
      // [INSERT IMAGE ALT TEXT — e.g. "large-format bathroom tiling and
      // waterproofing on a residential project, Auckland"]
      heroAlt="Large-format bathroom tiling and waterproofing on a residential project, Auckland"
      intro={[
        // [INSERT INTRO PARAGRAPH 1 — keywords: tiling Auckland, bathroom
        // tiling Christchurch, commercial tiling New Zealand, waterproofing]
        "Trust Flooring & Interiors installs precision tiling for residential and commercial projects across Auckland, Christchurch and New Zealand. From bathroom and kitchen wall tiling through to large-format commercial floors and tiles-on-pedestals systems, every installation is set out on site and laid to specification.",
        // [INSERT INTRO PARAGRAPH 2 — secondary keywords: interior
        // waterproofing, wet area tiling, large format tile installation]
        "Interior waterproofing is completed as part of the tiling scope where required — a single trade partner for the wet area envelope reduces defect risk and keeps the build programme moving. [Replace with a sentence on preferred tile brands, certifications or recent commercial tiling projects.]",
      ]}
      offerings={{
        heading: "Tiling services we offer.",
        items: [
          "Bathroom tiling",
          "Kitchen tiling",
          "Wall tiling",
          "Commercial tiling",
          "Tiles on Jacks / Pedestal",
          "Waterproofing — Interior",
        ],
      }}
      why={{
        heading: "Why specify Trust Flooring for tiling.",
        // [INSERT WHY PARAGRAPH]
        paragraph:
          "Tiling is where many interiors live or die — grout lines, set-out and falls either read well or they don't. Our tilers set out to the architect's drawings, coordinate falls and penetrations with the waterproofer, and leave a wet area that's sealed, true and cleanable.",
        points: [
          "Interior waterproofing and tiling under one trade",
          "Accurate set-out to architectural drawings",
          "Large-format and feature-tile experience",
          "Comfortable on residential, commercial and pedestal systems",
        ],
      }}
    />
  );
}
